
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/transaction_udiamond",
      function () {
        return require("private-next-pages/transaction_udiamond.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/transaction_udiamond"])
      });
    }
  